<template>
    <Top />
    <!-- Spinner Start -->
    <div id="spinner" v-if="halamanloading"
        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
        style="opacity: 0.5;">
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        &nbsp;<img src="../../../../src/assets/img/BerandaNgumahLogo.png" height="40">
        &nbsp;<span class="text-danger">..Loading...</span>
    </div>
    <!-- Spinner End -->
    <!-- Header Start -->
    <div class="container-fluid bg-breadcrumb">
        <div class="container text-center py-5" style="max-width: 900px;">
            <h3 class="text-white display-3 mb-4 wow fadeInDown pmisputih" data-wow-delay="0.1s">
                <span v-if="(bahasa === null) || (bahasa == 'ina')">TIM PMC NUFReP</span>
                <span v-else>NUFReP PMC TEAM</span>
            </h3>
            <ol class="breadcrumb justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
                <li class="breadcrumb-item">
                    <a href="/">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Beranda</span>
                        <span v-else>Home</span>
                    </a>
                </li>
                <li class="breadcrumb-item active text-primary">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">TIM PMC NUFReP</span>
                    <span v-else>NUFReP PMC TEAM</span>
                </li>
            </ol>
        </div>
    </div>
    <!-- Header End -->
    <!-- Contact Start -->
    <div class="container-fluid blog py-2">&nbsp;</div>
    <div class="container-fluid bg-breadcrumbberanda wow fadeInLeft py-2 px-5">
        <div class="col-sm-12 float-left pb-2">
            <span v-if="(bahasa === null) || (bahasa == 'ina')">Berikut ini adalah anggota tim PMC NUFRep:</span>
            <span v-else>The following are the PMC NUFRep team members:</span>
        </div>
        <div class="table-responsive table-wrapper">
            <table class="table m-0" id="tabeldata">
                <thead>
                    <tr>
                        <th style="width: 50px;" class="atas">No</th>
                        <th style="width: 300px;" class="atas">
                            <span v-if="(bahasa === null) || (bahasa == 'ina')">Nama</span>
                            <span v-else>Name</span>
                        </th>
                        <th style="width: 250px;" class="atas">
                            <span v-if="(bahasa === null) || (bahasa == 'ina')">Posisi</span>
                            <span v-else>Position</span>
                        </th>
                        <th style="width: 100px;" class="atas">
                            <span v-if="(bahasa === null) || (bahasa == 'ina')">Foto</span>
                            <span v-else>Photo</span>
                        </th>
                    </tr>
                </thead>
                <template v-for="(datalist, urutlist) in datamaster" :key="urutlist">
                    <tbody>
                        <tr>
                            <td :class="datalist.class" class="text-center">{{ urutlist + 1 }}</td>
                            <td :class="datalist.class" colspan="3">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">{{ datalist.nama }}</span>
                                <span v-else>{{ datalist.nama_eng }}</span>
                            </td>
                        </tr>
                        <tr v-for="(datadetail, urutdetail) in datalist.detail" :key="urutdetail">
                            <td :class="datadetail.class" class="text-center">{{ urutlist + 1 }}.{{ urutdetail + 1 }}
                            </td>
                            <td :class="datadetail.class" class="text-justify">{{ datadetail.nama }}</td>
                            <td :class="datadetail.class" class="text-justify">{{ datadetail.jabatan }}</td>
                            <td :class="datadetail.class" class="text-center">
                                <img :src="folder_foto + datadetail.filenya_foto" class="img-size-75 animation__wobble"
                                    alt="Image" style="height: 100px;">
                            </td>
                        </tr>
                    </tbody>
                </template>
            </table>
        </div>
    </div>
    <div class="container-fluid blog py-2">&nbsp;</div>
    <!-- Contact End -->
    
    <Footer />
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";
import CryptoJS from 'crypto-js';

export default {
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    components: {
        Top, Footer, swal
    },
    data() {
        return {
            halamanloading: true,
            tahun: new Date().getFullYear(),
            bahasa: localStorage.getItem("bahasasistem"),
            sourcenya: '',
            konten: '',
            datapesan: '',
            datamaster: [],
            carikata: '',
            folder_foto: process.env.VUE_APP_URL_API + 'maps_parastapainnovation_foto-Foto?f=',
            project_id: process.env.VUE_APP_PROJECT_ID,
        };
    },
    computed: {
        filteredKataData() {
            const filteredWorkers = this.carikata === ""
                ? this.datamaster
                : this.datamaster.filter(wo => Object.values(wo).join("").toLowerCase().indexOf(this.carikata.toLowerCase()) !== -1);
            return filteredWorkers;
        },
        JumlahfilteredKataData() {
            var jumlah = 0;
            try {
                if (this.filteredKataData === undefined) {
                    jumlah = 0;
                } else {
                    jumlah = this.filteredKataData.length;
                }
            }
            catch {
                jumlah = 0;
            }
            return jumlah;
        },
    },
    methods: {
        async ambildata() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovationtim-GetTim?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datamaster = [];
                        this.datamaster = Response.data.content.data;
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                this.datamaster = [];
                this.halamanloading = false;
            });
        },
    },
    mounted() {
        this.ambildata();
    },
}
</script>

<style></style>